const ProductTypeCell = (props: any) => {
  const productType = props?.tableProps?.testProductType;
  const formattedProductType =
    productType === 'ct_scan'
      ? 'CT Scan'
      : productType === 'lab_test'
      ? 'Lab Test'
      : productType;

  return (
    <div className='d-flex ms-5'>
      <div className='d-flex flex-row col '>
        <div className='d-flex flex-row align-items-center '>
            <span className='text-black fw-bold fs-7 '>{formattedProductType}</span>
        </div>
      </div>
    </div>
  )
}

export {ProductTypeCell}
